import React from 'react';
import styles from './index.module.scss'

const ERPOTourist = () => {
    return (
        <view className={styles.tourist}>
            <view className={styles.imageWrap}>
                <img className={styles.bdiImage4} src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/upload_to_oss_component/epro/scan_bind1702000517984.png'></img>
            </view>
            <view className={styles.desc}>
                暂无项目
            </view>
            <view className={styles.subDesc}>
                请联系医生邀请您加入项目
            </view>
        </view>
    )
}

export default ERPOTourist